// extracted by mini-css-extract-plugin
export var equalColumn = "_ew-0";